import { z } from 'zod';
import { apiGet, apiSend } from '@/lib/api';

/** Ustawienia instancji (03.11.2026) — na razie widoczność osób usuniętych z automatów w `/api/v1`. */
const UstawieniaInstancjiSchema = z.object({
  apiPokazujUsunietych: z.boolean(),
});

export type UstawieniaInstancji = z.infer<typeof UstawieniaInstancjiSchema>;

export const fetchUstawieniaInstancji = () => apiGet('/ustawienia-instancji', UstawieniaInstancjiSchema);

export const zapiszUstawieniaInstancji = (body: UstawieniaInstancji) =>
  apiSend('PUT', '/ustawienia-instancji', body, UstawieniaInstancjiSchema);
